import React, { useCallback } from 'react';
import { useTranslation } from '@weareconceptstudio/core';
import config from './_config';

export default function useGetLangPath() {
	const { selectedLang } = useTranslation();

	return useCallback(
		(key) => {
			let path = config.routes[key].path;
			return path;
		},
		[selectedLang]
	);
}
